module.exports = "./2b9b4872cd25494093c1eb14f0264a0b.svg";


//////////////////
// WEBPACK FOOTER
// ./~/jsoneditor/dist/img/jsoneditor-icons.svg
// module id = 92
// module chunks = 0